<template>
  <v-container fluid>
    <template v-if="renderizacaoLiberada">
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-row justify="center">
          <v-col cols="12">
            <parametros-padrao v-if="$route.params.data_registro" ref="parametrosREF" :item="item" />
            <parametros-ipca-estimado v-else ref="parametrosREF" :item="item" />
          </v-col>
          <v-col cols="12">
            <v-btn
              id="btn-salvar-indice-ipca"
              color="primary"
              min-width="100"
              style="float: right"
              class="mr-0 mt-n5"
              :disabled="invalid"
              :loading="loading"
              @click="salvar()"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </validation-observer>
    </template>
    <template v-else>
      <v-container fluid fill-height>
        <v-row align="center" class="mx-auto" style="height: 400px !important">
          <v-col cols="12" align="center" jusitfy="center">
            <v-progress-circular indeterminate color="primary" :size="100" />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-container>
</template>
<script>
  import AtualizacaoIndicesService from '@/services/AtualizacaoIndicesService';

  export default {
    components: {
      ParametrosPadrao: () => import('@/components/atualizacaoIndices/Parametros.vue'),
      ParametrosIpcaEstimado: () => import('@/components/atualizacaoIndices/ParametrosIpcaEstimado.vue')
    },

    data: () => ({
      item: {},
      loading: false
    }),

    computed: {
      renderizacaoLiberada() {
        if (!this.$route.params.data_registro) return true;

        return this.$route.params.data_registro && JSON.stringify(this.item) !== '{}' ? true : false;
      }
    },

    created() {
      if (this.$route.params.data_registro) {
        this.getIndice(this.$route.params.data_registro);
      }
    },

    methods: {
      getIndice(dataRegistro) {
        AtualizacaoIndicesService.getIndiceByDataRegistro(dataRegistro)
          .then((indice) => {
            this.item = indice.indice_estimado;
          })
          .catch(() => this.$toast.error('Erro ao buscar Índice IPCA.', '', { position: 'topRight' }));
      },

      salvar() {
        const data = this.$refs.parametrosREF.exportData();
        this.loading = true;

        AtualizacaoIndicesService.salvarIpcaEstimado(data)
          .then(() => {
            this.$toast.success('Índice IPCA salvo com sucesso.', '', { position: 'topRight' });
            this.$router.replace({ name: 'Atualização de Índices' });
          })
          .catch((err) => {
            console.error(err);
            if (err?.data?.error_code == 789) {
              console.error(err.data);
              this.$toast.error(err.data.erro, '', { position: 'topRight', timeout: 6000 });
            } else {
              this.$toast.error('Erro ao salvar índice IPCA.', '', { position: 'topRight' });
            }
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>